<template>
	<TransitionRoot as="template" :show="open">
		<Dialog as="div" static class="fixed z-20 inset-0 overflow-hidden" @close="$emit('close')" :open="open">
			<div class="absolute inset-0 overflow-hidden">
				<TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
					<DialogOverlay class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
				</TransitionChild>

				<div class="fixed inset-y-0 right-0 pl-2 sm:pl-10 max-w-full flex">
					<TransitionChild as="template" enter="transform transition ease-in-out duration-300" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-300" leave-from="translate-x-0" leave-to="translate-x-full">						
						<div class="w-screen max-w-2xl">
							<div class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
								<div class="min-h-0 flex-1 flex flex-col py-6 overflow-y-scroll">
									<div class="px-4 sm:px-6">
										<div class="flex items-start justify-between">
											<DialogTitle class="text-lg font-medium text-gray-900">
												{{ __('home::orders.delivery_info_title') }}
											</DialogTitle>
											<div class="ml-3 h-7 flex items-center">
												<button class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" @click="$emit('close')">
													<span class="sr-only">Close panel</span>
													<XIcon class="h-6 w-6" aria-hidden="true" />
												</button>
											</div>
										</div>
									</div>
									<div class="mt-6 relative flex-1 px-4 sm:px-6">
										
										<p class="whitespace-pre-line">{{ __('home::orders.delivery_info_content') }}</p>
										
									</div>
								</div>
								<div class="flex-shrink-0 px-4 py-4 flex justify-end">
									<button type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="$emit('close')">
										{{ __('forms::actions.close') }}
									</button>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

<script>
	import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
	import { XIcon } from '@heroicons/vue/outline'

	export default {
		components: {
			Dialog,
			DialogOverlay,
			DialogTitle,
			TransitionChild,
			TransitionRoot,
			XIcon,
		},
		props: {
			open: {
				type: Boolean,
				default: false,
			},
		},
	}
</script>